import { render, staticRenderFns } from "./PictimeCategoryProductList.vue?vue&type=template&id=3dfd86ec&scoped=true"
import script from "./PictimeCategoryProductList.vue?vue&type=script&lang=ts"
export * from "./PictimeCategoryProductList.vue?vue&type=script&lang=ts"
import style0 from "./PictimeCategoryProductList.vue?vue&type=style&index=0&id=3dfd86ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfd86ec",
  null
  
)

export default component.exports